
import UsersSettings from '@/views/Authorization/views/UsersSettings/UsersSettings.vue'

export default {
    name: 'ContractorUsers',
    components: { UsersSettings },
    props: {
        contractor: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            inViewport: false,
            observer: null as IntersectionObserver | null,
            isInEditMode: false,
        }
    },
    mounted() {
        const target = document.querySelector('#contractor-users') as HTMLElement
        this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.inViewport = true
                    this.observer?.unobserve(target)
                    break
                }
            }
        })
        this.observer.observe(target)
    },
    beforeDestroy() {
        this.observer?.disconnect()
    },
}
